module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp23_8.cfc8e11d.png";